import clsx from 'clsx';
import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { NODE_PARAGRAPH, render } from 'storyblok-rich-text-react-renderer';

export default function CompanyFacts(blok) {
  const { facts } = blok.blok;
  const styles = clsx('blok-company-facts');

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <div className="grid grid-cols-2 xl:grid-cols-4 my-10">
        {facts.map((edge, index) => {
          const fact = edge;
          return (
            <div
              className={`p-2 flex flex-wrap xl:flex-nowrap justify-center items-center ${
                index < facts.length - 1
                  ? 'xl-border-r-[inherit] xl:dark-border-r-white xl:border-r-2'
                  : ''
              }`}
              key={fact.value}
            >
              <span className="basis-full xl:basis-auto text-center xl:text-left font-bold text-latori-green-dark text-5xl xl:mr-4">
                {fact.value}
              </span>
              <span className="basis-full xl:basis-auto text-center xl:text-left w-32">
                {render(fact.label, {
                  nodeResolvers: {
                    // eslint-disable-next-line react/no-unstable-nested-components
                    [NODE_PARAGRAPH]: (children) => (
                      <p className="first-of-type:mt-0 last-of-type:mb-0">
                        {children}
                      </p>
                    ),
                  },
                })}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
